import axios from 'axios';
import React, { useEffect } from 'react';
import { alertRef } from '../../../App';
import Modal from '../../../Components/Modal/Modal';
import { Button } from '../../../Components/StyledComponents';
import Holiday from './Modals/Holiday';
import OperationHour from './Modals/OperationHour';
const RegularCycle = [
    '매주',
    '매월 첫번째',
    '매월 두번째',
    '매월 세번째',
    '매월 네번째',
    '매월 다섯번째',
    '매월 마지막주'
]
const RegularDay = [
    '월요일',
    '화요일',
    '수요일',
    '목요일',
    '금요일',
    '토요일',
    '일요일'
]

const OpertaionInfo = () => {
    const [info, setInfo] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(true)

    const pointRateRef = React.useRef(null);
    const operationRef = React.useRef(null);
    const holidayRef = React.useRef(null);
    const breakRef = React.useRef(null);
    const tempHolidayRef = React.useRef(null);
    const tempStopRef = React.useRef(null);

    useEffect(() => {
        getOperationInfo()
    }, [])

    const getOperationInfo = () => {
        axios.get('/api/pickup/order/info')
            .then((data) => {
                if (typeof data.data.TableOrderInfo !== 'undefined') setInfo(data.data.TableOrderInfo)
                setIsLoading(false)
            })
            .catch(() => {
                setIsLoading(false)
            })
    }

    const patchOperationHours = (val) => {
        axios.patch('/api/pickup/order/info/operation_hours', {
            OperationHours: {
                Everyday: val.Allday,
                Weekday: val.Weekday,
                Saturday: val.Saturday,
                Sunday: val.Sunday
            }
        })
            .then((data) => {
                if (data.status === 204) {
                    getOperationInfo();
                    operationRef.current.closeModal();
                    alertRef.current.showAlert({ title: '운영시간이 수정 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const patchDayoffs = (val) => {
        axios.patch('/api/pickup/order/info/day_offs', {
            DayOffs: {
                Holiday: val.Holiday,
                RegularHolidays: val.RegularHolidays
            }
        })
            .then((data) => {
                if (data.status === 204) {
                    getOperationInfo();
                    holidayRef.current.closeModal();
                    alertRef.current.showAlert({ title: '운영시간이 수정 되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: `다시 시도해 주세요.`, isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const convertPad = (val) => {
        return val.toString().padStart(2, '0')
    }

    return (
        <div>
            {
                !isLoading &&
                <>
                    <div className='info-box'>
                        <div className='row between'>
                            <div>
                                <p className='info-box-title'>운영시간</p>
                                <p className='info-sub-title'>우리 매장의 운영 시간을 설정해요.</p>
                            </div>

                            <Button variant="sub" className='edit-btn' onClick={() => operationRef.current.openModal()}>
                                수정하기
                            </Button>
                        </div>

                        <div className='header-divider' ></div>
                        {
                            (typeof info.OperationHours !== 'undefined' && Object.keys(info.OperationHours).length > 0) ?
                                info.OperationHours.Everyday === true ?
                                    <div className='row'>
                                        <p className='info-title'>모든 요일</p>
                                        {
                                            info.OperationHours.Weekday.Allday ?
                                                <p className='info-text'>24시간 영업</p>
                                                :
                                                <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Weekday.OpenHour)} : {convertPad(info.OperationHours.Weekday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Weekday.CloseHour)} : {convertPad(info.OperationHours.Weekday.CloseMin)}</p>
                                        }
                                    </div>
                                    :
                                    <>
                                        <div className='row' style={{ marginBottom: 16 }}>
                                            <p className='info-title'>평일</p>
                                            {
                                                info.OperationHours.Weekday.Allday ?
                                                    <p className='info-text'>24시간 영업</p>
                                                    :
                                                    <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Weekday.OpenHour)} : {convertPad(info.OperationHours.Weekday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Weekday.CloseHour)} : {convertPad(info.OperationHours.Weekday.CloseMin)}</p>
                                            }
                                        </div>
                                        <div className='row' style={{ marginBottom: 16 }}>
                                            <p className='info-title'>토요일</p>
                                            {
                                                info.OperationHours.Saturday.Allday ?
                                                    <p className='info-text'>24시간 영업</p>
                                                    :
                                                    <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Saturday.OpenHour)} : {convertPad(info.OperationHours.Saturday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Saturday.CloseHour)} : {convertPad(info.OperationHours.Saturday.CloseMin)}</p>
                                            }
                                        </div>
                                        <div className='row'>
                                            <p className='info-title'>일요일</p>
                                            {
                                                info.OperationHours.Sunday.Allday ?
                                                    <p className='info-text'>24시간 영업</p>
                                                    :
                                                    <p className='info-text'>영업 시작 : {convertPad(info.OperationHours.Sunday.OpenHour)} : {convertPad(info.OperationHours.Sunday.OpenMin)} ~ 영업종료 : {convertPad(info.OperationHours.Sunday.CloseHour)} : {convertPad(info.OperationHours.Sunday.CloseMin)}</p>
                                            }
                                        </div>
                                    </>
                                :
                                <p className='info-text'>운영시간을 설정해 주세요.</p>
                        }
                    </div>

                    <div className='info-box'>
                        <div className='row between'>
                            <div>
                                <p className='info-box-title'>휴무일</p>
                                <p className='info-sub-title'>우리 매장의 휴무일을 설정해요.</p>
                            </div>

                            <Button variant="sub" className='edit-btn' onClick={() => holidayRef.current.openModal()}>
                                수정하기
                            </Button>
                        </div>

                        <div className='header-divider' ></div>

                        {
                            typeof info.DayOffs === 'undefined' ?
                                <p className='info-text'>설정된 휴일이 없습니다.</p>
                                :
                                <div className='row'>
                                    <p className='info-title'>정기휴일</p>
                                    <div>
                                        {
                                            info.DayOffs.RegularHolidays.length === 0 ?
                                                <p className='info-text'>설정된 휴일이 없습니다.</p>
                                                :
                                                info.DayOffs.RegularHolidays.map((data, i) => {
                                                    return (
                                                        <p key={i} className='info-text'>{data.Interval === 255 ? '매월 마지막' : RegularCycle[data.Interval]} {RegularDay[data.Day]}</p>
                                                    )
                                                })
                                        }
                                    </div>
                                </div>
                        }

                        <div className='divider' />

                        <div className='row'>
                            <p className='info-title'>공휴일 휴무</p>
                            {
                                typeof info.DayOffs === 'undefined' ?
                                    <p className='info-text'>설정된 휴일이 없습니다.</p>
                                    :
                                    <p className='info-text'>{info.DayOffs.Holiday ? '휴무' : '미휴무'}</p>
                            }
                        </div>
                    </div>
                </>
            }
            <Modal ref={operationRef} contentContainer={{ width: 449 }} isHeader title={'운영시간 설정하기'}>
                <OperationHour info={info.OperationHours} patchOperationHours={patchOperationHours} />
            </Modal>

            <Modal ref={holidayRef} contentContainer={{ width: 422 }} isHeader title={'휴무일 설정하기'}>
                <Holiday info={info.DayOffs} patchDayoffs={patchDayoffs} />
            </Modal>
        </div>
    )
}

export default OpertaionInfo